import {
  CREATE,
  UPDATE,
  DELETE,
  FETCH_POST,
  FETCH_ALL,
  FETCH_BY_SEARCH,
  START_LOADING,
  END_LOADING,
  COMMENT,
} from "../constants/actionTypes";
import * as api from '../api';

export const getPost = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchPost(id);
    //dispatch({ type: FETCH_POST, payload: { post: data } });
    dispatch({ type: FETCH_POST, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const getPosts = (page) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING});
    const { data } = await api.fetchPosts(page);
    dispatch({ type: FETCH_ALL, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log("Get Post Error: " + error);
  }
};

export const getPostsBySearch = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data: { data } } = await api.fetchPostsBySearch(searchQuery);
    dispatch({ type: FETCH_BY_SEARCH, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const createPost = (post, navigate) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.createPost(post);
    navigate(`/posts/${data._id}`);
    dispatch({type: CREATE, payload: data});
  } catch (error) {
    console.log("Create Post Error: " + error);
  }
};

export const updatePost = (id, post) => async (dispatch) => {
  try {
     const { data } = await api.updatePost(id, post);
     dispatch({ type: UPDATE, payload: data});
  } catch (error) {
    console.log("Update Post Error: " + error);
  }
};

export const deletePost = (id) => async (dispatch) => {
  try {
    await api.deletePost(id);
    dispatch({ type: DELETE, payload: id});
  } catch (error) {
     console.log("Delete Post Error: " + error);
  }
}

export const likePost = (id) => async (dispatch) => {
  try {
    const { data } = await api.likePost(id);
    dispatch({ type: UPDATE, payload: data });
  } catch (error) {
    console.log("Like Post Error: " + error);
  }
}


export const commentPost = (comment, id) => async (dispatch) => {
  try {
      const { data } = await api.comment(comment, id);
      dispatch({ type: COMMENT, payload: data });
      return data.comments;  // Ensure that this returns the updated comments array
  } catch (error) {
      console.log('Error in commentPost:', error);
  }
};
